import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Broom } from "@phosphor-icons/react";
import { toast } from "sonner";
import { toastWithUndo } from "@/lib/dayUndo";

export default function ClearWeekButton({ program, weekStart, onDone }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const sectionCount = (program?.days || []).reduce((n, d) => n + (d.blocks || []).length, 0);

  const clear = async () => {
    setBusy(true);
    try {
      const { data } = await api.delete(`/programs/${program.id}/days`);
      setOpen(false);
      onDone?.();
      toastWithUndo(
        `Cleared week of ${weekStart} · ${data.removed_count} section${data.removed_count === 1 ? "" : "s"} deleted`,
        program.id, data.previous, onDone,
      );
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button variant="secondary" onClick={() => setOpen(true)} disabled={sectionCount === 0}
              className="rounded-xl text-terracotta" data-testid="clear-week-button">
        <Broom size={14} className="mr-2" /> Clear week
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="clear-week-confirm">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-heading">Clear the whole week?</AlertDialogTitle>
            <AlertDialogDescription>
              Deletes all {sectionCount} section{sectionCount === 1 ? "" : "s"} and day notes from Monday–Sunday
              (week of {weekStart}). Logged results and your coach&rsquo;s journal are kept. You&rsquo;ll have 10 seconds to undo.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="clear-week-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); clear(); }} disabled={busy}
              className="bg-terracotta hover:bg-terracotta-hover text-white" data-testid="clear-week-confirm-btn">
              {busy ? "Clearing…" : "Clear week"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
